import { AfterViewInit, Component, ElementRef, OnInit, ViewChild, Input } from '@angular/core';
import { MessageModel } from './model/message.model';
import { MessageService } from './service/message.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-message',
  templateUrl: './message.component.html',
})
export class MessageComponent implements OnInit, AfterViewInit {
  public message$: Observable<MessageModel | null>;
  @Input() public custom: boolean;
  @ViewChild('messageElement', { read: ElementRef, static: true })
  public el: ElementRef;

  constructor(private messageService: MessageService) {}

  ngOnInit() {
    this.message$ = this.messageService.state$;
  }

  ngAfterViewInit(): void {
    this.message$.subscribe((value) => {
      if (this.el && value) {
        if (this.custom) {
          const targetElement = this.el.nativeElement;
          targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } else window.scrollTo(0, 0);
      }
    });
  }

  onClose() {
    this.messageService.clear();
  }

  scroll(el: HTMLElement) {
    el.scrollIntoView();
  }
}
